import { SandboxErrorCode } from "./sandbox-error-code.enum";
import { SandboxPortfolioSetError } from "./sandbox-portfolio-set-error";

export class SandboxPortfolioSetNullError extends SandboxPortfolioSetError {
    code = SandboxErrorCode.PortfolioSetNull;
}
